import { Record } from 'immutable';
import { ButtonClickedEvent } from '../Events';
const defaultAnalyticsDataProps = {
  eventType: ButtonClickedEvent,
  actionSubjectId: '',
  attributes: undefined,
  category: undefined,
  containerId: undefined,
  containerType: undefined,
  objectId: undefined,
  objectType: undefined,
  tags: undefined
};
const defaultAnalyticsData = Record(defaultAnalyticsDataProps);
export const makeAnalyticsData = a => defaultAnalyticsData(a);